import React, { useEffect, useState } from 'react';
import ImageComponent from 'atoms/Image';
import { IMAGE_PATH } from 'common/ImageConstants/ImagePathUtils';
import { ButtonComp } from 'atoms/Buttons';
import { isMobileDevice } from 'common/utilities/utils';
import { useHistory } from 'react-router-dom';

const LocalThemeBanner = ({ data }) => {
  const [currentIndex, setCurrentIndex] = useState(0);
  const [description, setDescritpion] = useState([]);
  const [ctaButton, setCtaButton] = useState(null);
  const [isMobile, setIsMobile] = useState(isMobileDevice(window.innerWidth));
  const history = useHistory();
  const getDescription = (index = 0) => {
    const content = data[index]?.fields?.description?.content;
    const ctaButtonInfo = data[index]?.fields?.ctaButton;
    const contentInfo = [];
    content?.map(info => contentInfo.push(info?.content[0]));
    setDescritpion(contentInfo);
    setCtaButton(ctaButtonInfo);
  };

  useEffect(() => {
    getDescription();
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    window.addEventListener('resize', windowResized);
  }, [isMobile]);

  const windowResized = () => {
    setIsMobile(isMobileDevice(window.innerWidth));
  };

  const findOutMoreButton = dataTestId => (
    <>
      {description.forEach(desc => desc?.value && <span className='banner-desc'>{desc?.value}</span>)}
      {ctaButton && (
        <span className='find-more-btn'>
          <ButtonComp
            className='button blackButton blackBorder local-theme-btn'
            onClick={() =>
              ctaButton?.fields?.url
                ? history.push(ctaButton?.fields?.url)
                : window.open(ctaButton?.fields?.externalUrl, '_blank')
            }
            data-testid={dataTestId}
          >
            {ctaButton?.fields?.buttonText}
          </ButtonComp>
        </span>
      )}
    </>
  );

  return (
    <div className='local-theme-banner'>
      <div className='banner-container'>
        <div className='strip-icon'>
          <ImageComponent srcFile={IMAGE_PATH?.StripesIcon} />
        </div>
        <div className='column-container'>
          <div className='column-one'>
            {data.map((info, index) => {
              return (
                <>
                  <h2
                    className={`banner-heading ${currentIndex !== index && 'inactive'}`}
                    onClick={() => {
                      getDescription(index);
                      setCurrentIndex(index);
                    }}
                    data-testId='banner-heading-theme'
                  >
                    {info?.fields?.headline}
                  </h2>

                  {currentIndex === index && isMobile && <>{findOutMoreButton('find-out-more-theme-mobile')}</>}

                  {index !== data?.length - 1 && <div className='line'></div>}
                </>
              );
            })}
          </div>
          {!isMobile && <div className='column-two'>{findOutMoreButton('find-out-more-theme')}</div>}
        </div>
      </div>
    </div>
  );
};

export default LocalThemeBanner;
